'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientDetailedStatsListHeader = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientDetailedStatsListHeader, _PureComponent);

  function RecipientDetailedStatsListHeader() {
    (0, _classCallCheck3.default)(this, RecipientDetailedStatsListHeader);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientDetailedStatsListHeader.__proto__ || (0, _getPrototypeOf2.default)(RecipientDetailedStatsListHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientDetailedStatsListHeader, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var t = this.context.t;


      return _react2.default.createElement(
        _ListItem2.default,
        { fullWidth: true, isTitle: true, className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          'div',
          null,
          t('Track')
        ),
        _react2.default.createElement(
          'div',
          null,
          t('Listening Duration')
        ),
        _react2.default.createElement(
          'div',
          null,
          t('Time')
        )
      );
    }
  }]);
  return RecipientDetailedStatsListHeader;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = RecipientDetailedStatsListHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsListHeader.js
// module id = 2117
// module chunks = 1